/**
 * Validates whether a string is a valid email address format.
 * @param email The email address to validate
 * @returns True if the email format is valid; otherwise, false
 */
export function isValidEmail(email: string): boolean {
  if (!email || email.trim().length === 0) {
    return false;
  }

  // Simple email validation regex
  // Checks for: characters@characters.characters
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
}
